import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import { Modal, Button, Row, Col, message } from 'antd';

const css = require('./index.scss');
const billOrder = require('./img/bill_order.png');
const billPlan = require('./img/bill_plan.png');
const billInvoice = require('./img/bill_Invoice.png');
const billReceiving = require('./img/bill_receiving.png');
const billStockInNotice = require('./img/bill_stockInNotice.png');
const billActive = require('./img/bill_active.png');
const billDemand = require('./img/bill_demand.png'); // 要货计划单
const billPrediction = require('./img/bill_prediction.png'); // 预测计划
const billRATC01 = require('./img/bill_RATC01.png'); // 冲销入库单
const billReturn = require('./img/bill_Return.png'); // 退货通知单

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
   
        return (
                <Modal
                    title="转换单据类型"
                    width={550}
                    visible={this.modulesState.selectBillTypeM}
                    onOk={ModulesAction.changeBillTypeM}
                    onCancel={ModulesAction.changeBillTypeM}
                    footer={[
                        <Button key="back" onClick={ModulesAction.changeBillTypeM}>取消</Button>,
                        <Button key="submit" type="primary" onClick={this.submit} style={{ background: '#24B00D', borderColor: '#24B00D' }}>
                            确定
                        </Button>,
                    ]}
                >
                    <div className={css.selctTypeM}>
                        <Row>
                        {this.allowChooseType()}
                        </Row>
                    </div>
                </Modal>
            );
    }
    
    /**
     * 渲染可选 单据类型
     */
    private allowChooseType = () => {
        let list = [];
        // 文件类型 对应图片
        let actualDocType = {
            Order: billOrder,
            DespatchAdvice: billInvoice,
            ReceiptAdvice: billReceiving,
            StockInNotice: billStockInNotice,
            ForecastDemand: billDemand,
            ForecastPrediction: billPrediction,
            ReceiptAdviceRATC01: billRATC01,
            ReceiptAdviceReturn: billReturn,
        };
        this.modulesState.allowedDocType.forEach( (item, index)=> {
            if (actualDocType[item]){
                list.push(
                    <Col span={6} key={index}>
                        <div className={css.billItem} onClick={() => ModulesAction.billTypeChoose(item)}>
                            <img src={actualDocType[item]} alt="" />
                            {
                                this.modulesState.createBillType === item &&
                                <img src={billActive} className={css.billActive} />
                            }
                        </div>
                    </Col>
                );
            }
        });
        return list;
    }
    /**
     * 提交
     */
    private submit = () => {
        if (this.modulesState.createBillType) {
            //  转换
            ModulesAction.documentTransform(this.modulesState.createBillType);
        } else {
            message.warning('请选择转换单据类型!');
        }
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/DocumentDetail/UI.SelectBillTypeM.tsx